import dynamic from 'next/dynamic';
import { ComponentType } from 'react';
import { LoadingBaseProps } from './loading-base';

const LoadingBase: ComponentType<LoadingBaseProps> = dynamic(() => import('./loading-base'), {
  ssr: false
});

export default LoadingBase;
